// Columns of the tables money moves through: operator invoices, affiliate agreements, the payment
// and bank settings, wallets, credits and voucher codes. A percentage says so in its name, because a
// reader cannot tell 5 from 5% once the column name is gone.
export const MONEY_COLUMN_LABELS: Record<string, string> = {
  AccountHolderName: "Mbajtësi i llogarisë",
  AccountNumber: "Numri i llogarisë",
  BankName: "Banka",
  BankAccountNumber: "Numri i llogarisë bankare",
  IBAN: "IBAN",
  SWIFT: "SWIFT",
  VAT: "Numri i TVSH-së",
  BusinessUniqueId: "Numri unik i biznesit",
  AgencyName: "Emri i agjencisë",
  Address: "Adresa",
  FiscalNumber: "Numri fiskal",
  HeadQuarters: "Selia",
  InvoiceRecipientEmails: "Email-at që marrin faturën",
  AutoInvoiceEmailEnabled: "Fatura dërgohet automatikisht",
  AffiliateName: "Emri i afiliatit",
  AffiliateCode: "Kodi i afiliatit",
  PromoCode: "Kodi promocional",
  AllowMultipleUses: "Lejon përdorime të shumta",
  ApplicationNote: "Shënimi i aplikimit",
  AdminNote: "Shënimi i adminit",
  ApprovedDate: "Miratuar më",
  SocialMediaUrl: "Rrjeti social",
  Website: "Faqja e internetit",
  BusTicketCommissionPercentage: "Komisioni për bileta (%)",
  BusTicketDiscountPercentage: "Zbritja për bileta (%)",
  EsimCommissionPercentage: "Komisioni për eSIM (%)",
  EsimDiscountPercentage: "Zbritja për eSIM (%)",
  TotalPrice: "Totali",
  TotalOperatorAmount: "Shuma e operatorit",
  TotalGjirafaCommission: "Komisioni i Gjirafës",
  TotalCancellations: "Totali i anulimeve",
  NetBillable: "Shuma neto për faturim",
  CancelledAtUtc: "Anuluar më",
  CancelledByUserId: "Anuluar nga",
  SentAtUtc: "Dërguar më",
  AppliedServiceFeePercentage: "Tarifa e shërbimit (%)",
  IncludedFee: "Tarifa e përfshirë",
  IsInternational: "Ndërkombëtar",
  PdfLink: "Lidhja e PDF-së",
  JourneyId: "Rezervimi",
  OneWayTicketId: "Bileta e vajtjes",
  RoundWayTicketId: "Bileta e kthimit",
  isFirstClass: "Klasi i parë",
  isSecondClass: "Klasi i dytë",
  NotWorking: "Jashtë funksionit",
  WalletId: "Portofoli",
  WalletTransactionId: "Transaksioni i portofolit",
  CreditsExpiryAtUtc: "Gjirafa Money skadon më",
  LeaderboardAnonymousName: "Emri në renditje",
  LeaderboardNameMode: "Si shfaqet emri në renditje",
  DiscountRecieved: "Zbritja e marrë",
  HeldAmount: "Shuma e bllokuar përkohësisht",
  Product: "Produkti",
  RedeemableScope: "Ku mund të përdoret",
  IssuedByAdminId: "Dhënë nga admini",
  Note: "Shënimi",
  SourceCreditId: "Nga lëvizja e marrë",
  SpendCreditId: "Lëvizja që e përdori",
  IsUsed: "E përdorur",
  UsedAt: "Përdorur më",
  CreditAmount: "Shuma në Gjirafa Money",
  LockedToEmail: "I lidhur me email-in",
  AssignedToEmail: "Caktuar për email-in",
  AssignedAtUtc: "Caktuar më",
  Campaign: "Fushata",
  // A payment, a refund to the card and a bank dispute. Amounts the card processor counts in cents say
  // so, because 1250 next to a euro amount reads as a thousand euros.
  Rail: "Kanali i pagesës",
  GrossTotalCents: "Totali pa zbritur Gjirafa Money (në cent)",
  CreditsAmount: "Paguar me Gjirafa Money",
  PayableCents: "Për t'u paguar me kartelë (në cent)",
  CapturedCents: "Marrë nga kartela (në cent)",
  PromotionCodeMappingId: "Kodi promocional",
  PromoValidAtStart: "Kodi promocional ishte i vlefshëm",
  CaptureMode: "Kur merren paratë",
  AmountCents: "Shuma (në cent)",
  Currency: "Valuta",
  PaymentAttemptId: "Përpjekja për pagesë",
  RefundId: "Rimbursimi",
  FailureReason: "Arsyeja e dështimit",
  Origin: "Kush e nisi",
  StatusChangedAtUtc: "Statusi ndryshoi më",
  Outcome: "Rezultati",
  OpenedAtUtc: "Hapur më",
  ClosedAtUtc: "Mbyllur më",
  OperatorPaymentWithheld: "Pagesa e operatorit u ndal",
  OperatorDecisionAtUtc: "Vendimi për operatorin më",
  OperatorDecisionByUserId: "Vendimi për operatorin nga",
  PaymentDisputeId: "Kontestimi i pagesës",
  // What a cancellation paid back, and when: the refund's deadline and the bank's answer, the product
  // lines of the cash refund, and the ticket rows that take a cancellation off the operator's invoice.
  CreditsReturned: "Kthyer në Gjirafa Money",
  PayoutNotBeforeUtc: "Paguhet jo më herët se",
  ProcessorStatus: "Statusi i kthimit në kartelë",
  ProcessorConfirmedAtUtc: "Konfirmuar nga procesori i kartelës më",
  InvoiceLeg: "Pjesa e udhëtimit",
  ProductType: "Produkti",
  Vat: "Koeficienti i TVSH-së",
  Store: "Dyqani në QuickBooks",
  CanceledByUserId: "Anuluar nga",
  CanceledAtUtc: "Anuluar më",
  ManualCashInstructed: "Paguar me dorë nga financat (për gjithë anulimin)"
};

// The payment tables' plumbing, spread into HIDDEN_COLUMNS: the card processor's ids and passing
// remarks (the status columns already say what matters), a cancellation decision's key, a QuickBooks
// store id, the last QuickBooks send and its retries, and the form submission a grant came from.
export const MONEY_HIDDEN_COLUMNS = [
  "ProcessorRef",
  "PaymentIntentId",
  "ChargeId",
  "PaymentReference",
  "ProcessorRefundId",
  "ProcessorDisputeId",
  "OutcomeReason",
  "LastEventAtUtc",
  "CancellationId",
  "StoreId",
  "LastAttemptedPayloadJson",
  "LastAttemptError",
  "LastAttemptedAtUtc",
  "AttemptCount",
  "IssueRequestId"
];
